import React from "react";
import { ShieldCheck, Users, MapPin, Award } from "lucide-react";

const IMG_TRUST =
  "https://customer-assets.emergentagent.com/job_diaspora-care-hub/artifacts/hqwg1evz_WhatsApp%20Image%202026-06-03%20at%203.54.41%20PM%20%282%29.jpeg";

const PROMISES = [
  {
    icon: ShieldCheck,
    title: "Vetted professionals only",
    body:
      "Every referral partner is background-checked, certified, and reviewed against our internal standards.",
  },
  {
    icon: Award,
    title: "HEART Trust NTA certified team",
    body:
      "All caregivers hold formal certification or are trained on-the-job by certified instructors.",
  },
  {
    icon: Users,
    title: "Diaspora-friendly transparency",
    body:
      "Written updates and open communication loops with authorized family members overseas.",
  },
  {
    icon: MapPin,
    title: "Senior-suitability checklist",
    body:
      "Every home undergoes a strict accessibility and fall-risk audit before move-in.",
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="honeycomb py-28 md:py-36 bg-[var(--gg-surface)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src={IMG_TRUST}
                alt="Certified RN caregiver providing compassionate in-home care to a senior woman"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, transparent 25%, rgba(15,23,25,0.25) 55%, rgba(15,23,25,0.78) 100%)",
                }}
              />
              <div
                data-testid="grace-quote"
                className="absolute bottom-8 left-8 right-8 text-white"
              >
                <p className="font-serif italic text-3xl md:text-4xl leading-snug text-balance drop-shadow-md">
                  &ldquo;Grace is sufficient.&rdquo;
                </p>
                <p className="text-xs uppercase tracking-[0.28em] mt-3 opacity-90 font-medium">
                  Our quiet, founding principle
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="eyebrow">About Graceful Guidance</span>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] text-[var(--gg-deep)] mt-5 leading-[1.05] text-balance">
              Care worth coming home to —{" "}
              <em className="not-italic text-[var(--gg-primary)] font-normal">
                and worth staying for.
              </em>
            </h2>
            <p className="mt-7 text-lg text-[var(--gg-text)] leading-relaxed">
              We bridge the gap between daily lifestyle support and logistical
              relocation. Our integrated ecosystem reduces caregiver burnout,
              elevates the quality of life for seniors, and offers overseas
              families complete peace of mind.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-12">
              {PROMISES.map((p) => {
                const Icon = p.icon;
                return (
                  <div key={p.title} data-testid={`promise-${p.title}`} className="flex gap-4">
                    <span className="flex-shrink-0 w-11 h-11 rounded-full bg-white border border-[var(--gg-secondary)]/40 flex items-center justify-center text-[var(--gg-primary)]">
                      <Icon size={18} strokeWidth={1.5} />
                    </span>
                    <div>
                      <h3 className="font-serif text-xl text-[var(--gg-deep)]">
                        {p.title}
                      </h3>
                      <p className="text-sm text-[var(--gg-text)] leading-relaxed mt-1.5">
                        {p.body}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
